import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import RouteForm from "./RouteForm"
import { loadRoute, saveRoute } from "../../redux/actions/routeActions"
import { setupNavigation } from "../../redux/actions/navItemsActions"
import Spinner from "../common/Spinner";
import { toast } from "react-toastify";


function EditRouteDetailsPage({
    auth,
    route,
    routeId,
    loadRoute,
    saveRoute,
    history,
    setupNavigation,
    ...props
}) {

    const [routeDetails, setRouteDetails] = useState({name: "", category: "", description: "", private: false});
    const [errors, setErrors] = useState({});
    const [processing, setProcessing] = useState(false);

    useEffect(() => {
        document.title = "Edit Route | JustGoRide";
        setupNavigation({ sections: [] });
        //if (!route || route.routeId != routeId) {
            setProcessing(true);
            loadRoute(routeId, auth.accessToken)
                .then((r) => {
                    setRouteDetails(r)
                    setProcessing(false);
                })
                .catch(error => {
                    if (error.message === "401") {
                        history.push("/login");
                        return;
                    }
                    alert("Loading route failed: " + error);
                });
        //} else {
        //    setRouteDetails(route)
        //}
    }, []);

    function formIsValid() {
        const errors = {};
        var isValid = true;

        if (!routeDetails.name) {
            errors.name = "A route name is required.";
            setErrors(errors);
            isValid = false;
        }

        if (routeDetails.category != "Road" && routeDetails.category != "OffRoad" && routeDetails.category != "Gravel") {
            errors.category = "Please select a category.";
            setErrors(errors);
            isValid = false;
        }

        return isValid;
    }

    function handleChange(event) {
        var { name, value } = event.target;
        if (name === "publish") {
            name = "private"; 
            value = !event.target.checked; 
        }
        setRouteDetails(prevRouteDetails => ({
            ...prevRouteDetails,
            [name]: value
        }));
    }

    function handleSave(event) {
        event.preventDefault();

        if (!formIsValid()) return;

        setProcessing(true);

       saveRoute(routeDetails).then((result) => {
            toast.success("Route Updated!");
            setProcessing(false);
            history.push(`/routes/${route.routeId}`);
        })
        .catch(error => {
            setProcessing(false);
            setErrors({ onSave: error.message });
        });

    }

    function handleCancel(event) {
        history.push(`/routes/${route.routeId}`);
    }

    return (
        <div className="container">
            { processing ?
                <Spinner /> :
                (
                    <div className="row justify-content-md-center">
                        <div className="col-6 mt-5">
                            <h2>{route.routeId ? "Edit" : "Add"} Route</h2>
                            <RouteForm
                            route={routeDetails}
                            errors={errors}
                            onChange={handleChange}
                            onSave={handleSave}
                            onCancel={handleCancel}
                            processing={processing}
                                />
                        </div>
                    </div>
                )
            }
        </div>
    );

}

EditRouteDetailsPage.propTypes =
    {
        route: PropTypes.object.isRequired,
        routeId: PropTypes.string.isRequired,
        loadRoute: PropTypes.func.isRequired,
        saveRoute:PropTypes.func.isRequired,
        auth: PropTypes.object.isRequired,
        setupNavigation: PropTypes.func.isRequired
    }


function mapStateToProps(state, ownProps) {
    const id = ownProps.match.params.id; 
    return {
        routeId: id,
        route: state.route,
        auth: state.auth,
    };
}

const mapDispatchToProps = {
    loadRoute,
    saveRoute,
    setupNavigation
}

export default connect(mapStateToProps, mapDispatchToProps)(EditRouteDetailsPage); 


// WEBPACK FOOTER //
// ./src/components/routes/EditRouteDetailsPage.js